<!--
 * @Author: huboyi
 * @Date: 2022-03-24 10:53:24
 * @LastEditors: huboyi
 * @LastEditTime: 2022-03-28 19:33:55
 * @Description: 
-->
<template>
  <img
    :src="src"
    :style="{ width, height }"
    class="icon"
    alt="暂无图片"
    @click="click"
  />
</template>
<script>
export default {
  props: {
    src: {
      default: "",
    },
    size: {
      default: 16,
    },
    w: {
      default: 0,
    },
    h: {
      default: 0,
    },
  },
  data() {
    return {
      errorImg: 'this.src="' + require("../../assets/images/errorImg.png") + '"',
    };
  },
  computed: {
    width() {
      // let w = this.w || this.size;
      // return this.w || this.size + 'px'
      let px = this.w || this.size;
      if (typeof px == "number" || px.match(/^\d+$/) || px.match(/^\d+px$/)) {
        px = parseInt(px);
        // return window.lib.flexible.px2rem(px) + "rem";
        return px + "px";
      }
      return px;
    },
    height() {
      // return this.h || this.size + 'px'
      let px = this.h || this.size;
      if (typeof px == "number" || px.match(/^\d+$/) || px.match(/^\d+px$/)) {
        px = parseInt(px);
        // return window.lib.flexible.px2rem(px) + "rem";
        return px + "px";
      }
      return px;
    },
  },
  methods: {
    click(e) {
      this.$emit("click", e);
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.icon {
  object-fit: fill;
  display: inline-block;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/UI/Icon.vue